<!-- =========================================================================================
  File Name: ReportList.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="group-list-list-view" class="data-list-container">
		<template v-if="fullPath === '/apps/reports/list'">
			<bread-crumbs
				:title="$t('Reports.DownloadReports')"
				:subTitle="''"
				:sizeTitle="30"
				:lineHeightTitle="37"
				:sizeSubTitle="15"
				:lineHeightSubTitle="18"
			></bread-crumbs>
			<vx-card>
				<vx-card no-shadow :title="$t('Filters')">
					<div class="vx-row">
						<div class="vx-col md:w-3/5 w-full">
							<vs-tooltip color="primary" :text="$t('Reports.sort_by_description')" position="top">
								<label class="vs-input--label">{{ $t("Reports.sort_by") }}</label>
								<v-select
									v-model="order_by"
									multiple
									:clearable="true"
									:options="orderOptions"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
									label="label"
									value="value"
								>
								</v-select>
							</vs-tooltip>
						</div>

						<div class="vx-col md:w-1/5 w-full">
							<label class="vs-input--label">{{ $t("Reports.sorting_type") }}</label>

							<v-select
								v-model="sort"
								:clearable="false"
								:options="sortOptions"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								label="label"
								value="value"
							>
							</v-select>
						</div>

						<div class="vx-col md:w-1/5 w-full flex justify-between">
							<vs-button @click="getHistoryProcessFilter" color="primary" class="mt-6 w-full mr-2">{{
								$t("Search")
							}}</vs-button>
							<vs-button @click="cleanFilters" color="primary" class="mt-6 w-full">{{
								$t("Clear")
							}}</vs-button>
						</div>
					</div>
					<div class="vx-row mt-4">
						<div class="vx-col md:w-1/4" v-for="({value, label}, index) in order_by" :key="index">
							<div v-if="value === 'report_type'">
								<label class="vs-input--label">{{ $t("Reports.ReportType") }}</label>
								<v-select
									v-model="filters[value]"
									multiple
									:clearable="true"
									:options="reportTypeOptions"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
									label="label"
									value="value"
									class="w-full"
								>
								</v-select>
							</div>

							<div v-else-if="value === 'added_on' || value === 'date_init' || value === 'date_end'">
								<label class="vs-input--label">{{ $t("Reports." + value) }}</label>
								<vx-input-group class="mb-base w-full">
									<vs-input v-model="filters[value]" :dir="$vs.rtl ? 'rtl' : 'ltr'" type="date" />

									<template slot="append">
										<div class="append-text btn-addon">
											<vs-button color="primary" @click="filters[value] = null">
												<feather-icon icon="XSquareIcon" svgClasses="h-4 w-4" class="ml-1"
											/></vs-button>
										</div>
									</template>
								</vx-input-group>
							</div>

							<vs-input
								v-else-if="value === 'resource_id' || value === 'total_download_file'"
								v-model="filters[value]"
								:label="$t('Reports.' + value)"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								class="w-full"
								type="number"
							/>

							<vs-input
								v-else
								v-model="filters[value]"
								:label="$t('Reports.' + value)"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								type="text"
								class="w-full"
							/>
						</div>
					</div>
				</vx-card>
				<vs-table
					ref="table"
					v-model="selected"
					pagination
					:max-items="itemsPerPage"
					search
					:data="downloadReports"
				>
					<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
						<!-- ITEMS PER PAGE -->
						<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
							<div
								class="
									p-4
									border border-solid
									d-theme-border-grey-light
									rounded-full
									d-theme-dark-bg
									cursor-pointer
									flex
									items-center
									justify-between
									font-medium
								"
							>
								<span class="mr-2"
									>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
									{{
										downloadReports.length - currentPage * itemsPerPage > 0
											? currentPage * itemsPerPage
											: downloadReports.length
									}}
									of {{ queriedItems }}</span
								>
								<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
							</div>
							<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
							<vs-dropdown-menu>
								<vs-dropdown-item @click="itemsPerPage = 4">
									<span>4</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="itemsPerPage = 10">
									<span>10</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="itemsPerPage = 15">
									<span>15</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="itemsPerPage = 20">
									<span>20</span>
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>

					<template slot="thead">
						<vs-th sort-key="name">{{ $t("Reports.added_on") }}</vs-th>
						<vs-th sort-key="name">{{ $t("Reports.ReportType") }}</vs-th>
						<vs-th sort-key="category">{{ $t("InitDate") }}</vs-th>
						<vs-th sort-key="popularity">{{ $t("EndDate") }}</vs-th>
						<vs-th sort-key="popularity">{{ $t("Reports.TotalFiles") }}</vs-th>
						<vs-th>{{ $t("Action") }}</vs-th>
					</template>

					<template slot-scope="{data}">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td>
									<p class="product-price">{{ tr.added_on }}</p>
								</vs-td>
								<vs-td>
									<p class="product-name font-medium truncate">
										{{ tr.report_type }}
									</p>
								</vs-td>
								<vs-td>
									<p class="product-category">{{ tr.date_init }}</p>
								</vs-td>
								<vs-td>
									<p class="product-category">{{ tr.date_end }}</p>
								</vs-td>
								<vs-td>
									<p class="product-category">{{ tr.total_download_file }}</p>
								</vs-td>
								<vs-td class="whitespace-no-wrap">
									<feather-icon
										:title="$t('Reports.ShowFiles')"
										icon="FileTextIcon"
										svgClasses="w-5 h-5 hover:text-primary stroke-current"
										@click.stop="showReportFiles(tr)"
									/>
									<feather-icon
										:title="$t('Crud.Delete')"
										icon="TrashIcon"
										svgClasses="w-5 h-5 hover:text-danger stroke-current"
										class="ml-2"
										@click.stop="confirmDeleteReportProcess(tr)"
									/>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
			</vx-card>
		</template>
		<router-view></router-view>
	</div>
</template>

<script>
import moduleReport from "@/store/report/moduleReport.js";
import vSelect from "vue-select";

export default {
	components: {
		vSelect,
	},
	data() {
		return {
			selected: [],
			itemsPerPage: 10,
			isMounted: false,
			addNewDataSidebar: false,
			sidebarData: {},
			currentPageLocal: 1,
			quantityElementPage: 10,
			groupDelete: null,
			processDelete: null,
			fullPath: "",
			order_by: [{label: this.$t("Reports.added_on"), value: "added_on"}],
			sort: {label: this.$t("Reports.descendent"), value: "desc"},
			filters: {},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
		};
	},
	computed: {
		uploadfileReadPermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_R");
		},
		uploadfileCreatePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_C");
		},
		uploadfileUpdatePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_U");
		},
		uploadprocessDeletePermission() {
			return this.$store.getters.checkPermission("UPLOAD_FILES_D");
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		downloadReports() {
			return this.$store.state.moduleReport.downloads;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.downloadReports.length;
		},
		sortOptions() {
			return [
				{label: this.$t("Reports.ascendent"), value: "asc"},
				{label: this.$t("Reports.descendent"), value: "desc"},
			];
		},
		orderOptions() {
			return [
				{label: this.$t("Reports.id"), value: "id"},
				{label: this.$t("Reports.report_type"), value: "report_type"},
				{label: this.$t("Reports.date_init"), value: "date_init"},
				{label: this.$t("Reports.date_end"), value: "date_end"},
				{label: this.$t("Reports.resource_id"), value: "resource_id"},
				{label: this.$t("Reports.added_on"), value: "added_on"},
				{label: this.$t("Reports.update_on"), value: "update_on"},
				{label: this.$t("Reports.total_download_file"), value: "total_download_file"},
				{label: this.$t("Reports.download_file_id"), value: "download_file_id"},
			];
		},
		reportTypeOptions() {
			return [
				{label: this.$t("Reports.historicalposition"), value: "historical_position"},
				{label: this.$t("Reports.location"), value: "location"},
				{label: this.$t("Reports.loginout"), value: "login_logout"},
				{label: this.$t("Reports.transmission"), value: "transmission"},
				{label: this.$t("Reports.scheduledroute"), value: "scheduled_route"},
				{label: this.$t("Reports.resource"), value: "resource"},
				{label: this.$t("Reports.visitpoint"), value: "visit-point"},
				{label: this.$t("Reports.scheduledroutevsexecuted"), value: "scheduled_route_vs_executed"},
			];
		},
	},
	methods: {
		getHistoryProcessFilter() {
			const order_by = this.order_by.map((item) => item.value);
			const filtersKeys = Object.keys(this.filters);
			const payload = {
				sort: this.sort.value,
				order_by, // "added_on",
			};
			// add filters property if exist
			if (filtersKeys.length > 0 && order_by.length > 0) {
				const filters = {};
				filtersKeys.forEach((key) => {
					// if order_by includes key, then skip
					if (!order_by.includes(key) || this.filters[key] === null) {
						return;
					}

					if (key === "report_type") {
						filters[key] = this.filters[key].map((item) => item.value);
					} else if (key === "total_download_file" || key === "resource_id") {
						filters[key] = [Number(this.filters[key])];
					} else {
						filters[key] = [this.filters[key]];
					}
				});

				payload.filters = filters;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleReport/getProcessFilter", payload)
				.then((response) => this.closeLoading())
				.catch((error) => {
					this.closeLoading();
					console.error(error);
				});
		},
		download(data, filename, type) {
			var file = new Blob([data], {type: type});
			if (window.navigator.msSaveOrOpenBlob)
				// IE10+
				window.navigator.msSaveOrOpenBlob(file, filename);
			else {
				// Others
				var a = document.createElement("a"),
					url = URL.createObjectURL(file);
				a.href = url;
				a.download = filename;
				document.body.appendChild(a);
				a.click();
				setTimeout(function () {
					document.body.removeChild(a);
					window.URL.revokeObjectURL(url);
				}, 0);
			}
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		confirmDeleteReportProcess(data) {
			this.processDelete = data;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Record.DeleteRecord"),
				text: `${this.$t("Record.DeleteRecordConfirmText")} ${this.$t("Record.RecordNumber")}: ${
					this.processDelete.process_id
				}`,
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.openLoading();
			const payload = {
				process_id: this.processDelete.process_id,
				numFile: 0,
			};
			this.$store
				.dispatch("moduleReport/deleteHistoryReport", payload)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Record.DeleteRecord"),
						text: this.$t("Record.TextConfirmRecordDelete"),
					});
					this.closeLoading();
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					this.closeLoading();
				});
		},
		showReportFiles(data) {
			this.showFilter = false;
			this.$router.push({name: `apps-reports-list-id`, params: {id: data.id}}).catch(() => {});
		},
		cleanFilters() {
			this.filters = {};
			this.order_by = [{label: this.$t("Reports.added_on"), value: "added_on"}];
			this.sort = {label: this.$t("Reports.descendent"), value: "desc"};
			this.getHistoryProcessFilter();
		},
	},
	watch: {
		itemsPerPage(val) {
			this.currentPageLocal = 1;
		},
		$route(val) {
			this.fullPath = val.fullPath;
		},
	},
	created() {
		// register Module Group
		if (!moduleReport.isRegistered) {
			this.$store.registerModule("moduleReport", moduleReport);
			moduleReport.isRegistered = true;
		}
	},
	mounted() {
		this.isMounted = true;
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.fullPath = to.fullPath;
			if (from.name !== "apps-reports-list") {
				vm.getHistoryProcessFilter();
				next();
			}
		});
	},
};
</script>

<style lang="scss">
#group-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
